import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import { getApiErrorMessage } from '@/utils'
import { resetQueries } from '@/utils/api'

import { GET_MARKET_SHOP_INVENTORY_BASE_QUERY_KEY } from './get-market-shop-inventory'

type UnhideMarketShopInventoryItemRequest = {
  id: number
  buildingId: number
}

type BulkActionResponse = {
  affected: number
  failed: number[]
}

const unhideMarketShopInventoryItem = async (
  data: UnhideMarketShopInventoryItemRequest,
): Promise<BulkActionResponse> => {
  const response = await authAPI.post<BulkActionResponse>('/market-shop/products/bulk', {
    action: 'unhide',
    buildingId: data.buildingId,
    ids: [data.id],
  })
  return response.data
}

export const useUnhideMarketShopInventoryItem = () => {
  return useMutation({
    mutationFn: unhideMarketShopInventoryItem,
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
    onSuccess: async ({ affected }) => {
      await resetQueries([GET_MARKET_SHOP_INVENTORY_BASE_QUERY_KEY])
      if (affected > 0) {
        toastFactory.success('Item is now visible to residents')
      } else {
        toastFactory.error('Failed to unhide item')
      }
    },
  })
}
